module.exports = __webpack_public_path__ + "static/media/ic_info.7802875f.svg";